<mat-drawer-container>
  <mat-drawer-content>
    <div class="exports-content" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="column">
          <h1 class="report-header">Exports</h1>
        </div>
      </div>

      <search-bar
        [placeholder]="'Find file...'"
        [iconDirection]="'right'"
        (onChange)="searchExports($event)"
      ></search-bar>

      @if (isFetchingData) {
        <div class="waiting-spinner">
          <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
          <p>Loading...</p>
        </div>
      }

      <ng-scrollbar [track]="'all'">
        @if (this.dataSource.data.length && !isFetchingData) {
          <mat-table #table [dataSource]="dataSource">
            <ng-container matColumnDef="filename">
              <mat-header-cell *matHeaderCellDef> File Name </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><a
                  (click)="getS3Object(element.filePath)"
                  [class.disabled-link]="element.exportStatus != 'Success'"
                >
                  {{ element.fileName }}
                </a></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="lastModified">
              <mat-header-cell *matHeaderCellDef> Requested </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.requested | localDate }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="expiresIn">
              <mat-header-cell *matHeaderCellDef> Expires In </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                [ngClass]="{
                  'font-red':
                    this.expiresInFromLastModify(
                      element.requested,
                      14,
                      'days'
                    ).indexOf('day') === -1
                }"
              >
                {{ element.requested | expiresIn: 14 : 'days' }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                @if (element.exportStatus == 'Success') {
                  <a (click)="getS3Object(element.filePath)"
                    ><mat-icon aria-hidden="false" aria-label="Download"
                      >download</mat-icon
                    ></a
                  >
                }
                @if (element.exportStatus == 'Processing') {
                  <span class="status-processing">Processing...</span>
                }
                @if (element.exportStatus == 'Failed') {
                  <span class="status-failed"
                    ><mat-icon>error</mat-icon>Export Failed</span
                  >
                }
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        }
      </ng-scrollbar>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
